import {Model} from './model';
import {Unserializer} from './serialization';

export class LeadInformation implements Model {
  leadInformationId: string;
  ssn: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  companyName: string;
  companyBusinessId: string;
  iban: string;
  comments: string;
  ipAddress: string;
  modified?: Date;
  created?: Date;
  isCompleted: boolean;

  static copy(oldObj: LeadInformation): LeadInformation {
    const newObj = new LeadInformation();
    newObj.leadInformationId = oldObj.leadInformationId;
    newObj.ssn = oldObj.ssn;
    newObj.firstName = oldObj.firstName;
    newObj.lastName = oldObj.lastName;
    newObj.phone = oldObj.phone;
    newObj.email = oldObj.email;
    newObj.companyName = oldObj.companyName;
    newObj.companyBusinessId = oldObj.companyBusinessId;
    newObj.iban = oldObj.iban;
    newObj.comments = oldObj.comments;
    newObj.ipAddress = oldObj.ipAddress;
    newObj.modified = Unserializer.date(oldObj.modified);
    newObj.created = Unserializer.date(oldObj.created);
    newObj.isCompleted = oldObj.isCompleted;

    return newObj;
  }

  public getPrimaryKey(): string {
    return this.leadInformationId;
  }

  isNew(): boolean {
    return this.leadInformationId === null;
  }

  clone(): LeadInformation {
    return LeadInformation.copy(this);
  }
}
